import React from 'react';
import Button from '@mui/material/Button';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { PLATFORMS, usePlatform } from '@hmhco/platform-helper';
import useStyles from './RequestSignInDetailsButtons.styles';
import requestSignInDetails from '../../../../api/requestSiginDetails';
import useGetConnectionParam from '../../../../hooks/getConnectionParam.hook';
import {
  setRequestSigninDetailsError,
  setRequestSigninDetailsLoading,
  setRequestSigninDetailsSuccess,
} from '../../../../store/actions/RequestSigninActions';
import {
  getRequestSigninEmail,
  getIsRequestSigninValid,
} from '../../../../store/selectors/RequestSigninPageState';
import { getOrgRefIdFromOktaConfig } from '../../../../util/getOrgRefIdFromOktaConfig';

const RequestSignInDetailsButtons = ({ canSubmit }) => {
  const platform = usePlatform();
  const { classes } = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const currentEmail = useSelector(getRequestSigninEmail);
  const connection = useGetConnectionParam();
  const requestSigninEmailIsValid = useSelector(getIsRequestSigninValid);

  const onSubmit = async event => {
    event.preventDefault();
    const {
      requestSignInDetailsEd,
      requestSignInDetailsHnm,
      requestSignInDetailsNwea,
    } = requestSignInDetails();
    try {
      dispatch(setRequestSigninDetailsLoading());
      if (platform === PLATFORMS.FLIGHT) {
        await requestSignInDetailsHnm({
          email: currentEmail,
          districtId: connection,
        });
      } else if (platform === PLATFORMS.NWEA) {
        const orgRefId = getOrgRefIdFromOktaConfig();
        await requestSignInDetailsNwea({
          email: currentEmail,
          districtId: connection,
          orgRefId,
        });
      } else {
        await requestSignInDetailsEd({
          email: currentEmail,
          districtId: connection,
        });
      }
      dispatch(setRequestSigninDetailsSuccess());
    } catch (error) {
      dispatch(setRequestSigninDetailsError());
    }
  };

  const goBack = () => {
    history.goBack();
  };

  return (
    <div className={classes.buttons}>
      <Button
        variant="outlined"
        size="small"
        onClick={goBack}
        role="link"
        className={classes.button}
      >
        <FormattedMessage id="login.forgotPassword.backButton" />
      </Button>
      {canSubmit && (
        <Button
          disabled={!requestSigninEmailIsValid}
          data-testid="reqSiginSubmitButton"
          variant="contained"
          color="primary"
          size="small"
          type="submit"
          className={classes.button}
          onClick={onSubmit}
        >
          <FormattedMessage id="login.forgotPassword.submitButton" />
        </Button>
      )}
    </div>
  );
};

RequestSignInDetailsButtons.propTypes = {
  canSubmit: PropTypes.bool,
};
RequestSignInDetailsButtons.defaultProps = {
  canSubmit: false,
};

export default RequestSignInDetailsButtons;
